import { InjectionToken } from '@angular/core';

export interface CollegeCostEstimatorConfig {
  url: string;
}

export const COLLEGE_COST_ESTIMATOR_CONFIG = new InjectionToken<CollegeCostEstimatorConfig>(
  'college-cost-estimator.config',
);
